import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {zh as LoginZh, en as LoginEn} from './module_lang/Auth_lang'
import {zh as MenuZh, en as MenuEn} from './module_lang/Menu_lang'
import {zh as AIWorkBanch, en as AIWorkBanchEn} from './module_lang/AI_WorkBanch'

Vue.use(VueI18n)

let EN = {
  menu: MenuEn,
  login: LoginEn,
  ai: AIWorkBanchEn,
}

let ZH = {
  menu: MenuZh,
  login: LoginZh,
  ai: AIWorkBanch,
}
//window.localStorage.getItem('LANGUAGE')
export default new VueI18n({
  locale: window.localStorage.getItem('LANGUAGE'), // zh  en
  fallbackLocale: window.localStorage.getItem('LANGUAGE'),
  silentTranslationWarn: true,
  messages: {
    'zh': ZH,  //
    'en': EN
  },
  // messages: {
  //   en: {
  //     Starterkit : 'Starterkit',
  //     HellowWorld : 'HellowWorld',
  //   },
  //   ch: {
  //     Starterkit : '入门套件',
  //     HellowWorld : '你好，世界 ',
  //   },
  // },
})



// WEBPACK FOOTER //
// ./src/i18n/index.js